<template>
  <div class="c-subscribe-button__container">
    <template v-if="!isLoading && isLogged && user && currentUser">
      <template v-if="userMemberships">
        <BtnLink v-if="currentUser.forum_user.is_premium && userMemberships.length && hasSubscriptionEnded" url="/subscribe/?subscription=renew" class="u-mrxs">
          <SVGIcon class="c-button__link-icon" name="user" />
          <span class="c-button__label">{{ t('renew') }}</span>
        </BtnLink>
      </template>
      <BtnLink v-if="!currentUser.forum_user.is_premium" url="/subscribe/?subscription=upgrade" class="u-mrxs">
        <SVGIcon class="c-button__link-icon" name="user" />
        <span v-if="hasSubscriptionEnded" class="c-button__label">{{ t('upgrade') }}</span>
      </BtnLink>
    </template>
    <template v-else-if="!isLogged">
      <BtnLink url="/subscribe/?subscription=subscribe" class="u-mrxs">
        <SVGIcon class="c-button__link-icon" name="user" />
        <span class="c-button__label">{{ t('subscribe') }}</span>
      </BtnLink>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import {
  ProfileMembership,
  User,
  getUser
} from '@/utils/api'
import { useAuth } from '@/utils/auth'
// import { logDevOnly } from '@/utils/logs'
import { useI18n } from '@/utils/i18n'
import BtnLink from '@/components/buttons/BtnLink.vue'
import SVGIcon from '@/components/SVGIcon.vue'

const props = defineProps<{
  isAdmin: string
}>()

// logDevOnly()

const { isLogged, user } = useAuth()

const currentUser = ref<User>()
const currentMembership = ref<ProfileMembership>()
const userMemberships = ref<ProfileMembership[]>()

const isAdminUser = ref(false)
const isLoading = ref(true)

const hasActiveMembership = ref(false)
const hasSubscriptionEnded = ref(true)

watch([ isLogged, user ], async () => {
  // console.log('isLogged: ', isLogged.value)
  // console.log('user: ', user.value)

  if (user.value) {
    await getUserData()

    isLoading.value = false
  }
}, { immediate: true })

async function getUserData (): Promise<void> {
  // check if user is admin as props is a string and not a boolean
  if (props.isAdmin.includes('True')) {
    isAdminUser.value = true
  }

  if (user.value) {
    // get forum user
    await getUser(user.value?.pk!)
      .then((result) => {
        currentUser.value = result
      })
      .catch((err) => {
        console.log(err)
      })

    // get user membership
    userMemberships.value = currentUser.value!.forum_user.memberships
    currentMembership.value = getCurrentMembership()

    // check if user has active membership
    hasActiveMembership.value = currentUser.value!.forum_user.is_premium

    // check if user has subscription and if it has ended
    if (userMemberships.value!.length) {
      for (let i = 0; i < userMemberships.value!.length; i++) {
        if (userMemberships.value![i].is_valid) {
          hasSubscriptionEnded.value = false
        }
      }
    }
  }

  // console.log('USER: ', user.value)
  // console.log('CURRENT MEMBERSHIP: ', currentMembership.value)
  // console.log('hasActiveMembership: ', hasActiveMembership.value)
  // console.log('isLogged: ', isLogged.value)
  // console.log('isAdminUser: ', isAdminUser.value)
}

function getCurrentMembership (): ProfileMembership | undefined {
  if (userMemberships.value!.length) {
    for (let i = 0; i < userMemberships.value!.length; i++) {
      if (userMemberships.value![i].is_valid) {
        return userMemberships.value![i]
      }
    }
  }
}

onMounted(async () => {

})

const { t } = useI18n({
  messages: {
    en: {
      subscribe: 'Subscribe',
      upgrade: 'Upgrade',
      renew: 'Renew'
    },
    fr: {
      subscribe: "S'abonner",
      upgrade: 'Upgrade',
      renew: 'Renouveler'
    }
  }
})
</script>

<!-- <style scoped lang="scss">
</style> -->
